import { z } from 'zod'
export const ReduxActionSchema = z.object({ type: z.string() }).loose()

export type ReduxAction = z.infer<typeof ReduxActionSchema>
